import { groupBy } from 'lodash-es';

export const allowSuffix = ['png', 'dwg', 'glb', 'gmr', 'json', 'dxf'];

export const isAllowUpload = async (allFiles: any[], currentFile: any) => {
  allFiles.forEach((f) => {
    f.folderPath = f.webkitRelativePath?.replace('/' + f.name, '') || '';
  });
  // const isHasFolder = allFiles?.find(
  //   (f) =>
  //     f.folderPath?.includes(currentFile.folderPath) && f.folderPath !== currentFile.folderPath,
  // );
  const res = {
    upload: true,
    type: 'gmodeler',
  };

  const groups = groupBy(allFiles, 'folderPath');
  const currentGroup = groups[currentFile.folderPath];
  const glbs = currentGroup?.filter((f) => f.name?.toLowerCase()?.endsWith('.glb')) || [];
  const hasJson = currentGroup?.find((f) => f.name?.toLowerCase() === 'meta.json');

  //当前目录下没有glb，不处理
  if (glbs.length === 0) {
    res.upload = false;
  }
  //当前目录下有glb&没有json,或者glb数量大于1，当普通处理
  if ((glbs.length == 1 && !hasJson) || glbs.length > 1) {
    //只上传glb
    if (currentFile?.name?.toLowerCase()?.endsWith('.glb')) {
      res.upload = true;
      res.type = 'common';
    } else {
      res.upload = false;
    }
  }
  return res;
};

export const isEditAllowUpload = async (allFiles: any[], currentFile: any) => {
  allFiles.forEach((f) => {
    f.folderPath = f.webkitRelativePath?.replace('/' + f.name, '') || '';
  });
  const res = {
    upload: true,
    type: 'gmodeler',
  };
  //文件夹里的文件夹，不处理
  if (currentFile.folderPath?.includes('/')) {
    res.upload = false;
  }
  const groups = groupBy(allFiles, 'folderPath');
  const currentGroup = groups[currentFile.folderPath];
  const glbs = currentGroup?.filter((f) => f.name?.toLowerCase()?.endsWith('.glb')) || [];
  const hasJson = currentGroup?.find((f) => f.name?.toLowerCase() === 'meta.json');

  //当前目录下没有glb，不处理
  if (glbs.length === 0) {
    res.upload = false;
  }
  //当前目录下有glb&没有json,或者glb数量大于1，当普通处理
  if ((glbs.length == 1 && !hasJson) || glbs.length > 1) {
    //只上传glb
    if (currentFile?.name?.toLowerCase()?.endsWith('.glb')) {
      res.upload = true;
      res.type = 'common';
    } else {
      res.upload = false;
    }
  }
  return res;
};

export const isGmodelerFile = (allFiles: any[]) => {
  const glbs = allFiles?.filter((f) => f.name?.toLowerCase()?.endsWith('.glb')) || [];
  const hasJson = allFiles?.find((f) => f.name?.toLowerCase() === 'meta.json');
  if (glbs?.length === 1 && hasJson) {
    return true;
  }
  return false;
};

export const isGmodelerFileZip = (allFiles: any[]) => {
  const glbs = allFiles?.filter((f) => f.name?.toLowerCase()?.endsWith('.glb')) || [];
  const hasJson = allFiles?.find((f) => f.name?.toLowerCase() === 'meta.json');
  if (glbs?.length === 1 && hasJson) {
    return true;
  }
  return '上传文件不合规，请检查文件夹内文件类型';
};

export const isGmodelerFileWithId = async (allFiles: any[], cid: string) => {
  const glbs = allFiles?.filter((f) => f.name?.toLowerCase()?.endsWith('.glb')) || [];
  const hasJson = allFiles?.find((f) => f.name?.toLowerCase() === 'meta.json');
  const getJsonAnother = async (file: any) => {
    return new Promise((r) => {
      const reader = new FileReader();
      reader.readAsText(file, 'UTF-8');
      reader.onload = (evt) => {
        const fileString: any = evt?.target?.result || '';
        const jsonObj = JSON.parse(fileString);
        r({ name: jsonObj.name || '', id: jsonObj.guid || '', familyType: jsonObj.familyType })
      }
    })
  }
  const jsonFile = allFiles.filter((f) => f.name?.toLowerCase() === 'meta.json')[0]

  if (glbs?.length === 1 && hasJson) {
    const { id } = await getJsonAnother(jsonFile.fileStream || jsonFile) as any;
    if (cid === id) {
      return true;
    } else {
      return '不是同类构件'
    }
  }
  return '上传文件不合规，请检查文件夹内文件类型';
}
